"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterForHidingPresetsProps = void 0;
const hooks_1 = require("../custom-fields/widget-instance-field/hooks");
const useFilterForHidingPresetsProps = (schema, isPreset = false, propsAreHidden = false) => {
    const schemaForPreset = (0, hooks_1.usePropertiesFilter)(schema, schema === null || schema === void 0 ? void 0 : schema.uiSchema, 'ui:hiddenPropsFromUser');
    return isPreset && propsAreHidden && schemaForPreset ? schemaForPreset : schema;
};
exports.useFilterForHidingPresetsProps = useFilterForHidingPresetsProps;
//# sourceMappingURL=use-filter-for-hiding-presets-props.js.map